import { render, staticRenderFns } from "./RightBtn.vue?vue&type=template&id=558f6488&scoped=true&"
import script from "./RightBtn.vue?vue&type=script&lang=js&"
export * from "./RightBtn.vue?vue&type=script&lang=js&"
import style0 from "./RightBtn.vue?vue&type=style&index=0&id=558f6488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f6488",
  null
  
)

export default component.exports